import React, { useEffect, useMemo, useState } from "react";
import { Alert, Button, Card, InputTexto, Title } from "../components";
import { ErrorValidations, FormatRutValidator, RutValidator } from "../enums-lists/Validations";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { UserState } from "../types-interfaces/interfaces";
import { conciliationManual, getCollectionList, getPaymentList } from "../services/api-ssrr/CollectionManagerAPIClient";
import { TableSubtitleStyle, TableTitleStyle, TitleStyle } from "../components/styles/TitleStyle";
import { ManualBondingFilterRow1Style, ManualBondingFilterRowElementStyle, ManualBondingFilterStyle, ManualBondingStyle } from "../components/styles/FilterStyle";
import { PrimaryButtonStyle, SecondaryButtonDisabledStyle, SecondaryButtonStyle } from "../components/styles/ButtonStyle";
import { moneyFormat } from "../functions/Format";
import { SummaryAmountStyle, SummaryItemStyle, SummaryTableStyle } from "../components/styles/SummaryStyle";
import { ResultPaymentStyle, ResultStyle, ResultTitleStyle } from "../components/styles/SectionStyle";
import { MRT_RowSelectionState, MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { columnsCollectionManualLink, columnsPaymentsManualLink } from "../enums-lists/TableColumns";
import { AlertVariant, CollectionModel, PaymentModel } from "../types-interfaces/types";
import { Spinner } from "reactstrap";

interface VinculacionManualProps extends React.HTMLAttributes<HTMLElement>{
  className?: string | undefined
}

function VinculacionManual(props:VinculacionManualProps){
  const userState = useSelector<RootState, UserState>((state) => state.userState);
  const [rowSelectionPayments, setRowSelectionPayments] = useState<MRT_RowSelectionState>({});
  const [rowSelectionCollection, setRowSelectionCollection] = useState<MRT_RowSelectionState>({});
  const [isLoadingTablePayments, setIsLoadingTablePayments] = React.useState(false);
  const [isLoadingTableCollections, setIsLoadingTableCollections] = React.useState(false);
  const [isLinking, setIsLinking] = React.useState(false);
  const [rut, setRut] = React.useState("");
  const [viewingRut, setViewingRut] = React.useState("");
  const [error, setError] = React.useState("");
  const [errorRut, setErrorRut] = React.useState("");
  const [payments, setPayments] = React.useState<Array<PaymentModel> | undefined>(undefined);
  const [collections, setCollections] = React.useState<Array<CollectionModel> | undefined>(undefined);
  const [alertVariant, setAlertVariant] = React.useState<AlertVariant | undefined>(undefined);
  const [paymentsToLink, setPaymentsToLink] = React.useState(0);
  const [totalCLP, setTotalCLP] = React.useState(0);
  const [totalUSD, setTotalUSD] = React.useState(0);

  useEffect(() => {
    var newPaymentsToLink = 0;
    var newTotalCLP = 0;
    var newTotalUSD = 0;
    paymentTable.getSelectedRowModel().rows.forEach(pay => {
      newPaymentsToLink = newPaymentsToLink + 1;        
      if (pay.original.currencyType === "CLP"){
        newTotalCLP = newTotalCLP + pay.original.amount;
      }

      if (pay.original.currencyType === "USD"){
        newTotalUSD = newTotalUSD + pay.original.amount;
      }
    });
    setPaymentsToLink(newPaymentsToLink);
    setTotalCLP(newTotalCLP);
    setTotalUSD(newTotalUSD);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowSelectionPayments]);  

  async function llamadaAPI() {
    let paymentFinalResult:PaymentModel[] = [];
    let collectionFinalResult:CollectionModel[] = [];

    setIsLoadingTablePayments(true);
    let params = `page=${1}&size=${1}&customerId=${rut}`;
    let paymentsApi = await getPaymentList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

    if (!paymentsApi || typeof(paymentsApi) === 'string' || !paymentsApi.result || paymentsApi.result.length === 0){ 
      setAlertVariant("warning");
      setError("No se han encontrado pagos asociados al RUT ingresado.");
      setIsLoadingTablePayments(false);
      return;
    }
    
    for (let page = 1 ; page < ((paymentsApi.paging.total / 500) + 1); page ++){
      params = `page=${page}&size=500&customerId=${rut}`;
      paymentsApi = await getPaymentList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

      if (!paymentsApi || typeof(paymentsApi) === 'string' || !paymentsApi.result || paymentsApi.result.length === 0){ 
        setAlertVariant("warning");
        setError("No se han encontrado pagos asociados al RUT ingresado.");
        setIsLoadingTablePayments(false);
        return;
      }

      paymentFinalResult.push(...paymentsApi.result);
    }
    setIsLoadingTablePayments(false);
    
    if (paymentsApi && typeof(paymentsApi) !== 'string' && paymentFinalResult?.length > 0){
      paymentFinalResult = paymentFinalResult.filter(p =>
        (p.collectionId === null || p.collectionId.length === 0) &&
        (p.status === "Ingresada" || p.status === "Confirmada"));//TODO: llevar a enum
        
      setPayments(paymentFinalResult);  
    } else {
      setAlertVariant("warning");
      setError("No se han encontrado pagos asociados al RUT ingresado.");
      setIsLoadingTablePayments(false);
      return;
    }

    setIsLoadingTableCollections(true);
    params = `page=${1}&size=${1}&customerId=${rut}`;
    let collectionApi = await getCollectionList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

    if (!collectionApi || typeof(collectionApi) === 'string' || !collectionApi.result || collectionApi.result.length === 0){
      setAlertVariant("warning");
      setError("No se han encontrado cobranzas asociados al RUT ingresado.");      
      setIsLoadingTableCollections(false);
      return;
    }

    for (let page = 1 ; page < ((collectionApi.paging.total / 500) + 1); page ++){
      params = `page=${page}&size=500&customerId=${rut}`;
      collectionApi = await getCollectionList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

      if (!collectionApi || typeof(collectionApi) === 'string' || !collectionApi.result || collectionApi.result.length === 0){ 
        setAlertVariant("warning");
        setError("No se han encontrado cobranzas asociados al RUT ingresado.");
        setIsLoadingTableCollections(false);
        return;
      }

      collectionFinalResult.push(...collectionApi.result);
    }
    setIsLoadingTableCollections(false);
    
    if (collectionApi && typeof(collectionApi) !== 'string' && collectionFinalResult.length > 0){
      collectionFinalResult = collectionFinalResult.filter(c => c.status === "Ingresada")
      setCollections(collectionFinalResult);
    }

    if(collectionFinalResult === null || collectionFinalResult.length < 1) {
      setAlertVariant("warning");
      setError("No se han encontrado cobranzas asociados al RUT ingresado.");
      setIsLoadingTableCollections(false);
      return;
    }

    setError("");
    setAlertVariant(undefined);
  }

  function rutChangeHandler(evt: React.ChangeEvent<HTMLInputElement>){
    setErrorRut("");    
    let newRut = evt.currentTarget.value.toUpperCase();
    let oldRut = rut ?? newRut.substring(0,newRut.length-1);
    const regexp = new RegExp("^[0-9K-]+$");
    if (
      (newRut && !regexp.test(newRut)) ||
      (newRut.startsWith("0") || newRut.startsWith("K")) ||
      (newRut.includes("-") && newRut.split("-").length > 1 && newRut.split("-")[1].length > 1) ||
      (newRut.includes("-") && newRut.lastIndexOf("-") !== newRut.indexOf("-")) ||
      (newRut.includes("K") && newRut.lastIndexOf("K") !== newRut.indexOf("K"))
    ){
      evt.currentTarget.value = oldRut;
    } else {
      setRut(newRut);      
    }    
  }

  function handleClickGenerarConsulta(){    
    let error = false;
  
    //validaciones
    if (errorRut !== '' || rut === ''){
      error = true;
      setErrorRut(ErrorValidations.Required);      
    }
  
    if (error){      
      return;
    }    
    
    setViewingRut(rut);
    setCollections([]);
    setPayments([]);
    setRowSelectionCollection({});
    setRowSelectionPayments({});
    
    llamadaAPI();
  }

  async function handleClickVincularPago() {
    setIsLinking(true);
    let paymentsIds:Array<string> = []
    let responseApi = undefined;
    let collectionId = collectionTable.getSelectedRowModel().rows.at(0)?.original?.id;
    if ( paymentTable.getSelectedRowModel().rows &&
      collectionId &&
      userState.currentSession?.accessToken &&
      userState.currentSession.user?.email){
        paymentTable.getSelectedRowModel().rows.forEach((p) => { if (p.original.id) paymentsIds.push(p.original.id)});

      responseApi = await conciliationManual({ paymentIds: paymentsIds, collectionId: collectionId}, userState.currentSession?.accessToken, userState.currentSession?.user?.email);
    } else {
      setAlertVariant("warning");
      setError("No se pudo vincular el(los) pago(s) seleccionado(s) con la cobranza seleccionada");
      setIsLinking(false);
      return;
    }

    if (!responseApi || typeof(responseApi) === "string"){
      setAlertVariant("error");
      setError("Hubo un error al vincular el(los) pago(s) seleccionados con la cobranza seleccionada");
      setIsLinking(false);
      return;
    }

    if (responseApi.status){
      setAlertVariant("success");
      setError("Pago(s) vinculado(s) correctamente");
      setPayments([]);
      setCollections([]);
      setRut("");
      
      setTimeout(() => {
        setAlertVariant(undefined);
        setError("");              
      }, 5000);
    } else {
      setAlertVariant("error");
      setError(responseApi.message);      
    }
    setIsLinking(false);
  }

  const paymentTable = useMaterialReactTable({
    columns: useMemo(() => columnsPaymentsManualLink,[]),
    data: payments ?? [],
    muiTableContainerProps: {
      sx: { maxHeight: '35em' },      
    },
    enableSelectAll: false,
    enableRowSelection: true,    
    enableStickyHeader: true,
    enablePagination: false,
    enableColumnActions: false,
    enableDensityToggle:false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enableFilters: true,
    enableColumnFilters: false,
    enableBottomToolbar: false,
    onRowSelectionChange: setRowSelectionPayments,
    state:{ rowSelection: rowSelectionPayments, isLoading: isLoadingTablePayments }
  })

  const collectionTable = useMaterialReactTable({
    columns: useMemo(() => columnsCollectionManualLink,[]),
    data: collections ?? [],
    muiTableContainerProps: {
      sx: { maxHeight: '35em' },
    },
    enableRowSelection: true,
    enableMultiRowSelection: false,
    enableStickyHeader: true,
    enablePagination: false,    
    enableColumnActions: false,
    enableDensityToggle:false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enableFilters: true,
    enableColumnFilters: false,
    enableBottomToolbar: false,
    onRowSelectionChange: setRowSelectionCollection,
    state:{ rowSelection: rowSelectionCollection, isLoading: isLoadingTableCollections }
  })

  return(
  <div style={ManualBondingStyle}>
    <Title      
      text="Vinculación manual"
      style={TitleStyle}
    />
    <Card style={ManualBondingFilterStyle}>          
      <Card style={ManualBondingFilterRow1Style}>
        <Card style={ManualBondingFilterRowElementStyle}>
          <InputTexto
            className="filter-input"
            label="Filtrar por RUT del cliente"              
            value={rut}
            onChange={rutChangeHandler}              
            validators={[FormatRutValidator, RutValidator]}
            error={errorRut}
            alt="rut"
            styled="true"
            required
          />
          <div style={{display: "flex", alignItems: "flex-end", gap: "24px"}}>
            <Button
              style={PrimaryButtonStyle}  
              text="Generar Consulta"
              onClick={handleClickGenerarConsulta}
            />
          </div>
        </Card>
      </Card>
    </Card>    
    {error &&
      <Alert
        className={props.className + '-alert'}
        text={error}
        type={alertVariant}
        onClose={() => {setAlertVariant(undefined); setError("")}}
      />
    }
    {((payments && payments.length > 0) || isLoadingTablePayments ) &&
    <div className="result" style={ResultStyle}>
      <div className="payments" style={ResultPaymentStyle}>
        <div style={ResultTitleStyle}>
          <Title
            text="Pagos disponibles"
            style={TableTitleStyle}            
          />
        </div>
        <div>
          <Title
            text={`Para el rut del cliente: ${viewingRut}`}
            style={TableSubtitleStyle}                        
          />
          <MaterialReactTable table={paymentTable}/>
        </div>
        <div style={SummaryTableStyle}>
          <div style={SummaryItemStyle}>
            <span style={SummaryAmountStyle}>
              Pagos a vincular: {paymentsToLink}
            </span>
          </div>
          <div style={SummaryItemStyle}>
            <span style={SummaryAmountStyle}>
              Pagos en CLP: {moneyFormat(totalCLP,"CLP")}
            </span>              
          </div>
          <div style={SummaryItemStyle}>
            <span style={SummaryAmountStyle}>
              Pagos en USD: {moneyFormat(totalUSD,"USD")}
            </span>
          </div>
        </div>
      </div>
      {((collections && collections.length > 0) || isLoadingTableCollections ) &&
      <div className="collection">
        <div style={ResultTitleStyle}>
          <Title
            text="Cobranzas disponibles"
            style={TableTitleStyle}            
          />
        </div>
          <Title
            text={`Para el rut del cliente: ${viewingRut}`}
            style={TableSubtitleStyle}                        
          />
        <MaterialReactTable table={collectionTable}/>
      </div>
      
      }
      <div style={{ alignSelf:"center" }}>
        <Button        
          text="Vincular pagos"
          onClick={handleClickVincularPago}
          style={SecondaryButtonStyle}
          disabledstyle={SecondaryButtonDisabledStyle}
          disabled={(collectionTable.getSelectedRowModel().rows.at(0)?.original === undefined || paymentsToLink === 0 || isLinking)}
        >
        <Spinner 
          color="success"
          style={{height: '1rem', width: '1rem'}}
          hidden={!isLinking}
        />
        </Button>
      </div>      
    </div>
    }
  </div>
  )
}

export default VinculacionManual;